export default Object.freeze({
    TRANSFER_IN :'transfer_in',
    TRANSFER_OUT : 'transfer_out',
    SETTLED_IN : 'settled_in',
    SETTLED_OUT : 'settled_out',
    PENDING : 'pending',
    
  })